// extracted by mini-css-extract-plugin
export default {"inner-container":"change-log-modal_inner-container__LNEdy","message-container":"change-log-modal_message-container__AOFqc"};